import { FunctionComponent } from 'react';
import dynamic from 'next/dynamic';

import saveCheck from 'theme/icons/saveCheck.svg';

import LayoutContainer from 'components/layout/LayoutContainer';
import Spinner from 'components/layout/Spinner/component';
import Description from 'components/modules/public/layout/sections/Description';

import StyledComponent from './styles';
import { Props } from './types';

const DynamicSaveAnimation = dynamic(
    () => import('components/modules/public/layout/animations/SaveAnimation'),
    {
        loading: () => <Spinner />,
        ssr: false,
    }
);


const PublicPageOffersSectionSave: FunctionComponent<Props> = ({
    layoutContainerProps,
    descriptionProps,
    onSave,
    saved,
    saveAlt,
}) => {
    return (
        <StyledComponent
            className="public-page-offers-section-save"
        >
            <LayoutContainer
                {...layoutContainerProps}
            >
                <Description
                    {...descriptionProps}
                    onClick={onSave}
                    buttonProps={saved ? null : descriptionProps?.buttonProps}
                >
                    {saved && (
                        <div className="saved">
                            <img
                                src={saveCheck}
                                alt={saveAlt}
                                loading="lazy"
                            />
                            <span className="saved-txt">Zapisano</span>
                        </div>
                    )}
                </Description>
                <DynamicSaveAnimation />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicPageOffersSectionSave;